<template>
  <div class="radar-layout">
    <RadarForm />
    <RadarCardGrid />
  </div>
</template>

<script setup>
import RadarForm from '@/components/keyword-radar/RadarForm.vue'
import RadarCardGrid from '@/components/keyword-radar/RadarCardGrid.vue'
</script>
